import { render, staticRenderFns } from "./scientific-analysis-filter-panel-selectpatientidentifier.vue?vue&type=template&id=f225c83c&scoped=true&"
import script from "./scientific-analysis-filter-panel-selectpatientidentifier.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-filter-panel-selectpatientidentifier.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-filter-panel-selectpatientidentifier.scss?vue&type=style&index=0&id=f225c83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f225c83c",
  null
  
)

export default component.exports